<script lang="ts">
    import { _ } from "svelte-i18n"
    import Icon from "../../widgets/Icon.svelte"
    import { mdiFilter, mdiViewList, mdiViewModule } from "@mdi/js"
    import { tooltip } from "../../../helper"
    export let userFilter: any, resetFilter: () => void, gridBreakPoint: number, gridview: boolean, filteropen: boolean
</script>

<div class="tabletop">
    <div class="left">{$_("operationsOut.clickForMoreInfo")}</div>
    <div class="right">
        {#if userFilter?.length}
            <!-- Filter Trigger -->
            <div class="filter_reset active">
                <span class="icon"><Icon path="{mdiFilter}" size="24px" /></span>
                <a
                    href="/"
                    data-cy="reset"
                    on:click|preventDefault="{() => {
                        resetFilter()
                    }}"><span class="text">{$_("operationsOut.resetFilter")}</span></a
                >
                <span class="nr">{userFilter.length}</span>
            </div>
        {/if}

        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <div class="filter_trigger active" on:click="{() => (filteropen = true)}">
            <span class="icon"><Icon path="{mdiFilter}" size="24px" /></span>
            <span class="text">{$_("operationsOut.filter")}</span>
            {#if userFilter?.length}
                <span class="nr">{userFilter.length}</span>
            {/if}
        </div>

        {#if innerWidth > gridBreakPoint}
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <!-- svelte-ignore a11y-no-static-element-interactions -->
            <div
                class="item"
                class:active="{!gridview}"
                data-cy="tableview"
                on:click="{() => {
                    gridview = false
                }}"
                use:tooltip="{{ content: $_('operationsOut.tableView') }}"
            >
                <Icon path="{mdiViewList}" size="28px" />
            </div>
            <!-- svelte-ignore a11y-click-events-have-key-events -->
            <!-- svelte-ignore a11y-no-static-element-interactions -->
            <div
                class="item"
                class:active="{gridview}"
                data-cy="gridview"
                on:click="{() => {
                    gridview = true
                }}"
                use:tooltip="{{ content: $_('operationsOut.gridView') }}"
            >
                <Icon path="{mdiViewModule}" size="32px" />
            </div>
        {/if}
    </div>
</div>
